import { AbstractControl, UntypedFormGroup } from '@angular/forms';

/**
 * Parses value from string query params, where we can only store strings so there will be few
 * not allowed values like, a string false will result with false boolean being returned, a
 * string number will result in number being returned (only if this is a valid number).
 *
 * Values mapped:
 * 'true' => true
 * 'false' => false
 * '123.123' => 123.123
 * '33212' => 33212
 * 'some string' => 'some string'
 *
 * @param value - value to parse to a correct type
 */
export function parseValue(value: string): string | number | boolean {
    if (value === 'false') return false;
    if (value === 'true') return true;
    if (/^\d+$/.test(value)) return parseInt(value, 10);
    if (/^\d+(?:\.\d+)?$/.test(value)) return parseFloat(value);
    return value;
}

export function syncControlsWithQueryParams(
    formGroup: UntypedFormGroup,
    queryParams: { [key: string]: string }
) {
    Object.keys(formGroup.controls).forEach((controlName) => {
        if (queryParams[controlName]) {
            const control: AbstractControl = formGroup.get(controlName)!;
            control.setValue(parseValue(queryParams[controlName]));
        }
    });
}
